/** Sign drawn before an amount: none, a true minus (U+2212) or a plus. */
export type PriceSign = "none" | "minus" | "plus";

/** Options of `formatBRL`. */
export type FormatBRLOptions = {
  sign?: PriceSign;
  symbol?: boolean;
};

/** Currency symbol drawn before every amount; use it for field prefixes instead of a literal. */
export const CURRENCY_SYMBOL = "R$";

const SIGN_CHAR: Record<Exclude<PriceSign, "none">, string> = { minus: "−", plus: "+" };

/** Integer minor units (centavos) to reais. */
export function centsToReais(cents: number): number {
  return cents / 100;
}

/** Formats reais as "R$ 1.234,56" (pt-BR, 2 decimals); a negative value is drawn with U+2212 unless `sign` says otherwise. */
export function formatBRL(value: number, { sign, symbol = true }: FormatBRLOptions = {}): string {
  const rounded = parseFloat(value.toFixed(2));
  const amount = Math.abs(rounded).toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const body = symbol ? `${CURRENCY_SYMBOL} ${amount}` : amount;
  const resolved = sign ?? (rounded < 0 ? "minus" : "none");
  return resolved === "none" ? body : `${SIGN_CHAR[resolved]} ${body}`;
}
